import React, { Fragment } from "react";
import CustomPropTypes from "../../utils/customPropTypes";
import ImageBlock from "../ImageBlock";
import SafeHTML from "../SafeHTML";
export default class ProductCard extends React.Component {
  static propTypes = {
    product: CustomPropTypes.Product
  };
  constructor(props) {
    super(props);
    this.state = {
      active: false
    };
  }
  toggleClass = () => {
    const currentState = this.state.active;
    this.setState({ active: !currentState });
  };
  render() {
    let objProduct = this.props.product;
    if (objProduct)
      return (
        <>
          <a
            href={objProduct.url}
            className={"product-card" + (this.state.active ? " active" : "")}
            onClick={() => {
              this.toggleClass();
            }}
          >
            <div className="product-card-inner">
              <h4 className="product-card-title">{objProduct.name}</h4>
              <div className="product-card-data">
                <SafeHTML>{objProduct.description}</SafeHTML>
              </div>
              <div className="product-card-object">
                <ImageBlock image={objProduct.image} addWrapper={false} />
              </div>
              <div className="product-card-action">
                <i className="icon icon-direction-right"></i>
              </div>
            </div>

            <div className="product-card-hover">
              <h4 className="product-card-title">{objProduct.name}</h4>
              <div className="product-card-data">
                <SafeHTML>{objProduct.description}</SafeHTML>
              </div>
              <div className="product-card-action">
                <i className="icon icon-direction-right"></i>
              </div>
            </div>
          </a>
        </>
      );
    else return null;
  }
}
